module.exports = __webpack_public_path__ + "static/media/google-sheets.c521aab8.png";